import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imageFull: false,
    image: '',
    audio: false,
    soundState: true,
    soundFundo: false,
    start: true,
  },
  mutations: {
    openFullImage(state, image) {
      console.log(image)
      state.image = image
      state.imageFull = true
    },
    startSound(state) {
      state.start = false
      state.soundFundo = true
    },
    startNoSound(state) {
      state.start = false
      state.soundFundo = false
    },
    closeFullImage(state) {
      state.imageFull = false
    },
    playAudio(state) {
      state.audio = true
    },
    stopAudio(state) {
      state.audio = false
    },
    changeSoundState(state, newSound) {
      state.soundState = newSound
    },
    desligarFundo(state) {
      state.soundFundo = false
    },
    ligarFundo(state) {
      state.soundFundo = true
    },
  },
  actions: {},
  modules: {},
})
